<template>
  <div class="page">
    <!-- 问题详情 -->
    <problemIndex :problemData.sync="problemData"></problemIndex>
  </div>
</template>

<script>
import { getStorage, setStorageNew } from "@/util/localStor";
import {
  queryHistoryList,
  getQuestionListApi,
  afterFeedbackEditApi,
  preProblemEditApi,
} from "@/api/feedback";
import problemIndex from "@/components/problemDetails/problemIndex.vue";
export default {
  components: { problemIndex },
  data() {
    return {
      problemData: {}, // 问题详情
      newProblemData: {},
      // originalData: {},
    };
  },
  async created() {
    // 问题详情
    this.problemData = getStorage("problemData");
    // this.originalData = getStorage("problemData");
  },
  watch: {
    problemData: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
          this.newProblemData = newVal;
          this.perHandleSave();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getFileInfo(fileItem) {
      const value = fileItem;
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        try {
          return JSON.parse(value) || [];
        } catch {
          return [];
        }
      }
      // 其他情况（undefined/null）→ 返回空数组
      return [];
    },
    async perHandleSave() {
      this.$loading.hide();
      try {
        if (this.newProblemData) {
          const submitData = JSON.parse(JSON.stringify(this.newProblemData));
          if (Array.isArray(submitData.faultCommonFiles)) {
            submitData.faultCommonFiles =
              submitData.faultCommonFiles.length === 0
                ? ""
                : JSON.stringify(submitData.faultCommonFiles);
          }
          if (Array.isArray(submitData.faultVideoFiles)) {
            submitData.faultVideoFiles =
              submitData.faultVideoFiles.length === 0
                ? ""
                : JSON.stringify(submitData.faultVideoFiles);
          }
          if (Array.isArray(submitData.faultCodeFiles)) {
            submitData.faultCodeFiles =
              submitData.faultCodeFiles.length === 0
                ? ""
                : JSON.stringify(submitData.faultCodeFiles);
          }
          if (Array.isArray(submitData.otherFiles)) {
            submitData.otherFiles =
              submitData.otherFiles.length === 0
                ? ""
                : JSON.stringify(submitData.otherFiles);
          }
          let maintenanceRecordObj = {
            engineRecordList: submitData.maintenanceRecordInfo.engineRecordList,
            transmissionRecordList:
              submitData.maintenanceRecordInfo.transmissionRecordList,
          };
          submitData.maintenanceRecord = JSON.stringify(maintenanceRecordObj);
          submitData.maintenanceRecordInfo = maintenanceRecordObj;
          let res = {};
          res = await getQuestionListApi({ data: submitData });
          if (res.status == 0) {
            setStorageNew("problemData", submitData);
              // this.problemData = getStorage("problemData")
              // this.dialogVisible = false;
              // this.$DonMessage.success("操作成功");
              // this.$emit("success", res.data);
          } else {
              // this.$DonMessage.error(res.message);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
